<template>
  <section class="internal-layout">
    <div class="internal-layout__inner row">
      <div class="columns">
        <slot />
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'InternalLayout',
};
</script>

<style lang="scss">
.internal-layout {
  padding-top: $lb-expand-top-padding;

  @include breakpoint(large) {
    padding-top: $lb-expand-top-padding * 2;
  }

  &__inner {
    width: 95%;
    margin: auto;
    max-width: 80em;
  }
}
</style>
